(function (angular) {
  "use strict";

  var MAX_LOAD_TAGS_QUERY_LENGTH = 3;
  var changeLocationModalId = "change-location";

  angular.module("Toyota.Directives").directive("tyLocationChange", [
    "$q",
    "$filter",
    "CssMediaWatcher",
    "SitecoreAnalytics",
    "PageOptions",
    "LocationManager",
    "Tfy",
    function ($q, $filter, CssMediaWatcher, SitecoreAnalytics, PageOptions, LocationManager) {
      var controller = [
        "$scope",
        "$rootScope",
        "Postcodes",
        "Location",
        "Region",
        "Dealer",
        "$attrs",
        "$element",
        "$window",
        "DealerInventoryService",
        "ModalService",
        "Tfy",
        function (
          $scope,
          $rootScope,
          Postcodes,
          Location,
          Region,
          Dealer,
          $attrs,
          $element,
          $window,
          DealerInventoryService,
          ModalService,
          Tfy
        ) {
          var previousDealerBranchCode = "";

          var saveLocation = function (postCode, suburb, state, region, pricingZone, source) {
            Location.update(postCode, suburb, state, region, pricingZone, source);

            $scope.postCode = postCode;
            $scope.suburb = suburb;
            $scope.state = state;
            $scope.region = region;
            $scope.pricingZone = pricingZone;
            $scope.source = source;

            if (!$scope.allowDealerSelection) {
              $scope.closeModal();
            }
          };

          $scope.isLocationSaved = function () {
            return !!$scope.postCode && $scope.postCode !== "";
          };

          $scope.isDealerSaved = function () {
            return !!$scope.dealerSaved && $scope.dealerSaved.name !== "";
          };

          var saveDealer = function (dealer) {
            Tfy.updateDealerInTfyCookie(dealer.sapDealerCode, dealer.branchCode);

            Dealer.updateSaved(dealer);
            $scope.dealerSaved = dealer;

            $rootScope.$broadcast("dealer-selected");
            /*
             * See OmnichannelCta.tsx for similar behaviour
             * implemented in a more modern way
             *
             */
            if ($scope.checkLocalStock.loadPage) {
              SitecoreAnalytics.triggerGoal($scope.checkLocalStock.sitecoreAnalyticsGoalId);
              $window.open(
                DealerInventoryService.urlWithCampaignTracking(
                  dealer.stockUrl,
                  $scope.checkLocalStock.utmMedium,
                  $scope.checkLocalStock.utmTerm
                ),
                "_blank"
              );
            }

            $scope.delaySwitch = true;
            $scope.closeModal();
          };

          $scope.saveDealer = function (index) {
            var dealer = $scope.dealers[index];

            (async () => {
              var dealerObject = dealer;

              try {
                const tags = await Postcodes(dealerObject.postCode, 1);
                const pricingZone = tags?.[0]?.tagInfo?.pricingZone;
                if (pricingZone) {
                  dealerObject.pricingZone = pricingZone;
                }
              } catch (e) {}

              saveDealer(dealerObject);
            })();
          };

          $scope.closeModal = function () {
            $rootScope.$broadcast("modal-close", changeLocationModalId);
          };

          $scope.dealerFullAddress = function () {
            if (!!$scope.dealerSaved && $scope.dealerSaved.address !== "") {
              var fullAddress = "";

              fullAddress += $scope.dealerSaved.address + ", ";
              fullAddress += $scope.dealerSaved.city + ", ";
              fullAddress += $scope.dealerSaved.state + " ";
              fullAddress += $scope.dealerSaved.postCode;

              return fullAddress;
            }

            return "";
          };

          $scope.dealerFullAddressMaps = function () {
            if ($scope.dealerFullAddress() !== "") {
              return $scope.dealerSaved.name + ", " + $scope.dealerFullAddress();
            }

            return "";
          };

          var saveTag = function (tagInfo) {
            $scope.tags[0] = {
              id: 0,
              tagInfo: {
                postCode: tagInfo.postcode,
                state: tagInfo.state,
                suburb: tagInfo.suburb,
                pricingZone: tagInfo.pricingZone,
              },
              text: tagInfo.suburb + ", " + tagInfo.postcode + " " + tagInfo.state,
            };
          };

          $scope.changeDealer = function () {
            if ($scope.isLocationSaved()) {
              var locationObject = LocationManager.getLocationObject();
              if (locationObject.postcode !== "") {
                saveTag(locationObject);
              }

              // we want to capture the location tag of the saved dealer before it's cleared
              if ($scope.isDealerSaved()) {
                LocationManager.setPrevSavedLocation();
              }

              $scope.showLanding = false;
              $scope.fetchDealers($scope.postCode, $scope.suburb);
            }
          };

          var resetStates = function () {
            $scope.dealers = [];
            $scope.tags = [];
            $scope.text = "";

            $scope.loading = false;
            $scope.geoLoading = false;

            $scope.showLanding = true;
            $scope.locationSet = false;
            $scope.displayDealers = false;
            $scope.errorInGeoLocation = false;

            // Delay switching from select dealer to selected for better ux
            $scope.delaySwitch = false;

            var locationObject = LocationManager.getLocationObject();
            if (locationObject.postcode !== "") {
              saveTag(locationObject);
            }

            $scope.postCode = locationObject.postcode;
            $scope.suburb = locationObject.suburb;
            $scope.pricingZone = locationObject.pricingZone;
            $scope.dealerSaved = Dealer.getSaved();
            previousDealerBranchCode = Dealer.getSavedFallbackToDefault().branchCode;
          };

          $scope.selectDealership = function () {
            // if location is set and no dealer is set, show available dealers on landing
            if (
              $scope.showLanding &&
              $scope.isLocationSaved() &&
              !$scope.hasSelectedDealership() &&
              $scope.displayDealers
            ) {
              return true;
            }
            // show available dealers on results page
            else if (!$scope.showLanding && $scope.displayDealers) {
              return true;
            }

            return false;
          };

          $scope.hasSelectedDealership = function () {
            return $scope.showLanding && $scope.dealerSaved.name !== "";
          };

          $scope.fetchDealers = function (postcode, suburb) {
            if (!$scope.allowDealerSelection) {
              return;
            }

            $scope.dealers = [];
            $scope.displayDealers = true;
            $scope.loading = true;
            LocationManager.triggerDidLocationChangeDealersLoadBegin();

            LocationManager.fetchDealers(postcode, suburb, $scope.checkLocalStock)
              .then(function (response) {
                $scope.dealers = response;
              })
              .finally(function () {
                // saved dealer will reset when saved dealer changes so we need to preserve the previous choice here
                if ($scope.isDealerSaved()) {
                  LocationManager.setPrevSavedDealerState(Dealer.getDefault(), Dealer.getSaved());
                }

                var firstDealer = $scope.dealers[0];
                Tfy.updateDealerInTfyCookie(firstDealer?.sapDealerCode ?? null, firstDealer?.branchCode ?? null);
                LocationManager.setDefaultDealerAndResetSavedDealer(firstDealer);
                $scope.dealerSaved = Dealer.getSaved();
                $scope.loading = false;
                LocationManager.triggerDidLocationChangeDealersLoadEnd();

                $scope.displayDealers = true;
                $rootScope.$broadcast("dealer-selected");
              });
          };

          $scope.onCurrentLocation = function () {
            $scope.tags = [];
            $scope.text = "";
            $scope.showLanding = false;
            $scope.geoLoading = true;
            $scope.loading = true;
            $scope.displayDealers = false;

            return LocationManager.getCurrentLocation($attrs.tyLocationChangeErrorMessageInvalidCountryToast).then(
              function (response) {
                saveLocation(
                  response.postcode,
                  response.suburb,
                  response.state,
                  response.region,
                  response.pricingZone,
                  response.source
                );

                var postcodeObject = LocationManager.getLocationObject();
                if (postcodeObject.postcode !== "") {
                  saveTag(postcodeObject);
                }

                $scope.geoLoading = false;
                $scope.loading = true;
                $scope.locationSet = true;
                $scope.fetchDealers(response.postcode, response.suburb);
              },
              function (response) {
                $scope.geoLoading = false;
                $scope.loading = false;
                $scope.errorInGeoLocation = {
                  isInvalidCountry:
                    typeof response.message === "string" && response.message.match(/^Invalid country code/),
                  isInvalidRequest:
                    typeof response.message === "string" && response.message.match(/^Postal code not found/),
                  isLocationBlocked:
                    response.message.message &&
                    typeof response.message.message === "string" &&
                    response.message.message.match(/^User denied Geolocation/),
                };
              }
            );
          };

          function init() {
            resetStates();
            $scope.checkLocalStock = {
              materialCode: "",
              utmMedium: "",
              utmTerm: "",
              loadPage: false,
            };

            $scope.allowDealerSelection =
              $attrs.tyLocationChangeAllowDealerSelection === "True" || $scope.isDealerSaved();

            // when opening the modal, reset the location error
            $scope.$on("modal-open", function (event, modalId) {
              if (modalId !== changeLocationModalId) {
                return;
              }

              resetStates();
              if (!$scope.hasSelectedDealership() && $scope.isLocationSaved()) {
                $scope.fetchDealers($scope.postCode, $scope.suburb);
              }

              $scope.locForm.$setUntouched();
              $scope.locForm.$setPristine();
            });

            $scope.$on(
              "check-local-stock",
              function (event, materialCode, utmMedium, utmTerm, sitecoreAnalyticsGoalId) {
                $scope.checkLocalStock.materialCode = materialCode;
                $scope.checkLocalStock.utmMedium = utmMedium;
                $scope.checkLocalStock.utmTerm = utmTerm;
                $scope.checkLocalStock.loadPage = true;
                $scope.checkLocalStock.sitecoreAnalyticsGoalId = sitecoreAnalyticsGoalId;
              }
            );

            $scope.$on("modal-close", function () {
              $scope.checkLocalStock.loadPage = false;
              var dealerChanged = previousDealerBranchCode !== Dealer.getSavedFallbackToDefault().branchCode;

              if (PageOptions.getReloadOnDealerLocationChange() && dealerChanged) {
                if (ModalService.isModalOpen(changeLocationModalId)) {
                  ModalService.preventReopenOnReload();
                }

                $window.location.reload();
              }
            });
          }

          $scope.onTagAdd = function ($tag) {
            $scope.tags = [];
            $scope.tags[0] = $tag;
            $scope.text = "";
            $scope.loading = true;

            Region($tag.tagInfo.postCode, $tag.tagInfo.suburb).then(function (region) {
              // we want to capture the location tag of the saved dealer before it's updated
              if ($scope.isDealerSaved()) {
                LocationManager.setPrevSavedLocation();
              }

              $scope.locationSet = true;
              saveLocation(
                $tag.tagInfo.postCode,
                $tag.tagInfo.suburb,
                $tag.tagInfo.state,
                region,
                $tag.tagInfo.pricingZone
              );
              $scope.fetchDealers($tag.tagInfo.postCode, $tag.tagInfo.suburb);
            });
          };

          $scope.loadTags = function (query) {
            var deferred = $q.defer();
            $scope.errorInGeoLocation = false;

            if (query.length === 0) {
              if ($scope.tags.length === 0) {
                $scope.showLanding = true;
                $scope.locationSet = false;
                $scope.displayDealers = false;
                $scope.loading = false;
              }
            } else {
              $scope.dealers = [];
              $scope.locationSet = false;
              $scope.displayDealers = false;

              var viewportWidth = CssMediaWatcher({
                $el: $element,
                pseudoEl: "before",
                mediaProperty: "viewportWidth",
                mediaRegexes: {
                  mobile: "^mobile$",
                  desktop: "^desktop$",
                },
              }).getCurrentMedia().viewportWidth;

              // Only in mobile, scroll up when foreground element is hidden
              if ($scope.showLanding === true && viewportWidth.is.mobile) {
                var scrollHeight = $element.find(".location-info__foreground").height();
                $window.scrollBy(0, -scrollHeight);
              }

              $scope.showLanding = false;
            }

            if (query.length < MAX_LOAD_TAGS_QUERY_LENGTH) {
              deferred.resolve([]);
              return deferred.promise;
            }

            $scope.loading = true;
            var maxResults = $attrs.tyLocationChangeMaxResults;
            var x = Postcodes(query, maxResults);

            x.then(function (tags) {
              $scope.loading = false;

              deferred.resolve(tags);
            });

            return deferred.promise;
          };

          init();
        },
      ];

      return {
        scope: true,
        restrict: "A",
        controller: controller,
        bindToController: true,
        controllerAs: "locationChangeController",
      };
    },
  ]);
})(window.angular);
